import { api } from '@/lib/api-client';
import { CreditBalanceResponse } from '@/types/credits';
import { useApiQuery } from './useApiQuery';

export function useCreditBalance(userId?: string) {
  return useApiQuery<CreditBalanceResponse>(
    ['credit-balance', userId ?? ''],
    () => (userId ? api.getCreditBalance(userId) : Promise.resolve(undefined as never)),
    { enabled: !!userId },
  );
}
